'use client';
import { jsxs as l, jsx as o } from "react/jsx-runtime";
import * as m from "@radix-ui/react-switch";
import { cn as t } from "@tameeni/shared-logic";
import * as d from "react";
import { Label as f } from "../label/label.js";
import { thumbVariants as g, toggleVariants as h } from "./toggle.variants.js";
const N = d.forwardRef(({ className: s, containerClassName: e, size: a, id: c, label: r, ...n }, p) => {
  const i = c || r;
  return /* @__PURE__ */ l("div", { className: t("flex items-center gap-2", e), children: [
    /* @__PURE__ */ o(
      m.Root,
      {
        ref: p,
        id: i,
        "aria-label": r || "toggle",
        className: t(h({ size: a, className: s })),
        ...n,
        children: /* @__PURE__ */ o(m.Thumb, { className: t(g({ size: a })) })
      }
    ),
    r && /* @__PURE__ */ o(f, { htmlFor: i, className: "cursor-pointer", children: r })
  ] });
});
N.displayName = m.Root.displayName;
export {
  N as Toggle
};
